<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new tarrif rate</small>
      </legend>
      <div>
        <form @submit.prevent="newTarrif()">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Tarrif category</label>
                <select name="tarrif_category" class="form-control tarrif_category">
                  <option value>Select category</option>
                  <option value="ADMINISTRATIVE">ADMINISTRATIVE</option>
                  <option value="OPERATION">OPERATION</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Item name</label>
                <input type="text" class="form-control item_name" placeholder="item name" required />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingTarrif">
            <i class="fa fa-ship"></i> create tarrif
          </button>
          <button type="button" class="btn btn-info btn-flat creatingTarrifLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  created() {},
  methods: {
    ...mapActions(["newTarrif"])
  }
};
</script>
<style scoped>
.creatingTarrifLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/tarrifs/tarrif.vue